import React from "react";
import {Button} from "reactstrap";

const Reset = ({resetTest=f=>f, isLink=false, linkText="button"}) => isLink ?
    <button className="btn btn-link p-0" role="link" onClick={resetTest}>{linkText}</button> :
    <Button role={"link"} onClick={resetTest}>{linkText}</Button>;

export default Reset